export var redirectPage = function (url) {
    window.location.replace(url);
};
